<ng-container *ngIf="gridInitialized else loadingTemplate">
  <mat-accordion>
    <mat-expansion-panel #expansionPanelFilters aria-label="Filters Panel" [expanded]="true"
                         [ngClass]="{ 'sticky-panel': expansionPanelFilters.expanded }"
                         (afterCollapse)="resultsContainer.scrollTop = 0">
      <mat-expansion-panel-header>
        <mat-panel-title class="font-weight-bold">{{ gridConfigs?.gridTitle }}</mat-panel-title>
        <mat-panel-description class="justify-content-end">
          <strong class="d-flex align-items-center">
            <mat-icon class="h-auto" fontSet="fas" fontIcon="fa-filter"></mat-icon>
            {{ expansionPanelFilters.expanded ? 'Hide' : 'Show' }} Filters
          </strong>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <ng-ut-filters-form-container
          [filtersSettings]="filtersConfigs"
          [filtersExtraSettings]="filtersExtraConfigs"
          [filtersFormName]="gridConfigs?.gridName"
          [gridName]="gridConfigs?.gridName"
          (saveFilters)="saveFilters($event)"
          (createReport)="createReport($event)">
        </ng-ut-filters-form-container>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div #resultsContainer class="results-container mt-1" [ngClass]="{ 'overflow-auto': !expansionPanelFilters.expanded }">
    <div *ngIf="type === eUTGridType.RELEASE_EMPTIES" class="mb-2 px-2">
      <form [formGroup]="releaseEmptiesForm">
        <div class="row w-100">
          <div class="col-sm">
            <mat-radio-group class="mt-3 w-100" formControlName="timezone" aria-label="timezone">
              <mat-radio-button value="L" checked>Release Station's local time</mat-radio-button>
              <mat-radio-button value="E">Eastern Standard Time</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-sm">
            <mat-form-field appearance="outline" class="mt-3 w-100" color="accent">
              <mat-label>Cars Placed</mat-label>
              <input formControlName="carsPlaced" matInput [owlDateTime]="carsPlaced" [owlDateTimeTrigger]="carsPlaced">
              <owl-date-time #carsPlaced></owl-date-time>
            </mat-form-field>
          </div>
          <div class="col-sm">
            <mat-form-field appearance="outline" class="mt-3 w-100" color="accent">
              <mat-label>Dumping Started</mat-label>
              <input formControlName="dumpingStarted" matInput [owlDateTime]="dumpingStarted"
                     [owlDateTimeTrigger]="dumpingStarted">
              <owl-date-time #dumpingStarted></owl-date-time>
            </mat-form-field>
          </div>
          <div class="col-sm">
            <mat-form-field appearance="outline" class="mt-3 w-100" color="accent">
              <mat-label>Dumping Finished</mat-label>
              <input formControlName="dumpingFinished" matInput [owlDateTime]="dumpingFinished"
                     [owlDateTimeTrigger]="dumpingFinished">
              <owl-date-time #dumpingFinished></owl-date-time>
            </mat-form-field>
          </div>
          <div class="col-sm">
            <mat-form-field appearance="outline" class="mt-3 w-100" color="accent">
              <mat-label>ReleaseDate</mat-label>
              <input formControlName="releaseDate" matInput [owlDateTime]="releaseDate" [owlDateTimeTrigger]="releaseDate"
                     [min]="yesterday"
                     [max]="tomorrow">
              <owl-date-time #releaseDate></owl-date-time>
            </mat-form-field>
          </div>
          <div class="col-sm">
            <mat-form-field appearance="outline" class="mt-3 w-75" color="accent">
              <mat-label>Enter total weight of dumped cars</mat-label>
              <input formControlName="totalWeight" matInput type="number">
            </mat-form-field>
            <mat-select formControlName="weightScale" class="w-25 pl-1">
              <mat-option value="T">Tons</mat-option>
              <mat-option value="P">Pounds</mat-option>
            </mat-select>
          </div>
        </div>
      </form>
      <div class="row w-100">
        <div class="col-sm">
          <strong>#Cars:</strong> {{ releaseEmptiesHeader?.cars }}
        </div>
        <div class="col-sm">
          <strong>#Cars Unable to Release:</strong> {{ releaseEmptiesHeader?.carsNotReleased }}
        </div>
        <div class="col-sm">
          <strong>NS
            Arrival:</strong> {{ releaseEmptiesHeader?.nsArrival ? (releaseEmptiesHeader?.nsArrival | date:'MM/dd/yyyy hh:mm a') : '' }}
        </div>
        <div class="col-sm">
          <strong>NS
            Placement:</strong> {{ releaseEmptiesHeader?.nsPlacement ? (releaseEmptiesHeader?.nsPlacement | date:'MM/dd/yyyy hh:mm a') : '' }}
        </div>
      </div>
    </div>
    <ns-grid class="h-100" *ngIf="gridConfigs"
             [name]="gridConfigs.gridName"
             [gridTitle]="gridConfigs.gridTitle"
             [subtitleMsg]="subtitleMsg"
             [rowSelection]="gridConfigs.rowSelection"
             [config]="gridConfigs.headerOptions"
             [data]="data"
             [columns]="gridConfigs.columns"
             [loading]="loading"
             [gridOptions]="gridConfigs.options"
             [autoGroupColumnDef]="gridConfigs.options.autoGroupColumnDef"
             (ready)="setGrid($event)"
             (refresh)="emitMakeAdvanceSearch()">
      <ng-container grid-footer *ngIf="type === eUTGridType.LOAD_TRAIN">
        <button mat-flat-button aria-label="Click Next" class="ml-2 flex-shrink-1" color="accent" (click)="emitNext()"
                [disabled]="!grid?.api?.getSelectedRows()?.length">
          Click Next
        </button>
      </ng-container>
      <ng-container *ngIf="type === eUTGridType.TRAIN_CONSIST" grid-header>
        <div class="row w-100">
          <div class="col text-center">
            <div><strong>Train</strong></div>
            <div>{{ trainConsist?.trainId }}</div>
          </div>
          <div class="col text-center">
            <div><strong>Current Location</strong></div>
            <div>{{ trainConsist?.currentLocation }}</div>
          </div>
          <div class="col text-center">
            <div><strong>Total Cars</strong></div>
            <div>{{ trainConsist?.totalCars }}</div>
          </div>
          <div class="col text-center">
            <div><strong>Latest Move Date</strong></div>
            <div>{{ trainConsist?.latestMoveDate | date:'MM/dd/yyyy hh:mm a' }}</div>
          </div>
          <div class="col text-center">
            <div><strong>Latest Crew Call</strong></div>
            <div>{{ trainConsist?.latestCrewCall | date:'MM/dd/yyyy hh:mm a' }}</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="type === eUTGridType.TRAIN_SET_INQUIRY" grid-header>
        <div class="w-100 text-right">
          Total Train Set(s): {{ data.length }}
        </div>
      </ng-container>
      <ng-container *ngIf="type === eUTGridType.RELEASE_EMPTIES" grid-footer>
        <button mat-flat-button color="accent" class="mr-2" aria-label="Confirm Release"
                (click)="confirmRelease()" [disabled]="!grid?.api?.getSelectedRows()?.length && releaseEmptiesForm.valid">
          Confirm Release
        </button>
      </ng-container>
      <ng-container *ngIf="type === eUTGridType.TRAIN_SIZE_PERFORMANCE && data.length" grid-footer>
        <div class="row w-100 permit-size-properly">
          <div class="col">
            <strong>Permit Size Properly</strong>
          </div>
          <div class="col">
            <strong>#WBD</strong> {{ data[0].permitsSizeProperlyCarsWayBilled }}
          </div>
          <div class="col">
            <strong>%Var(Wbd-STD)</strong> {{ data[0].permitsSizeProperlyPercentageWayBilledCars }} %
          </div>
        </div>
      </ng-container>
    </ns-grid>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>
